export default __webpack_public_path__ + "static/media/okdesuka.993bab3a.wav";